import React from 'react';

import VehicleCardLoader from '../../components/vehicleCardLoader/VehicleCardLoader';
import styles from './loadingComponent.module.scss';

export const LoadingComponent = ({}) => (
  <div className={styles['loading-component']}>
    {Array.from({ length: 3 }, (_, index) => (
      <VehicleCardLoader key={index} />
    ))}
  </div>
);
